<script setup lang="ts">

import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons'

import { TutorCategoryType } from '@entities/tutor'
import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'

import PaymentPolicyRow from './PaymentPolicyRow.vue'
import { useTutorKanbanPolicy } from '../model/tutor-kanban-policy.hook'

defineOptions({
  name: 'TutorKanbanPolicy',
})

const { setEdit } = useTutorKanbanPolicy()

</script>

<template>
  <div class="tutor-policy">
    <div class="tutor-policy__header">
      <AppText name="body1-medium">
        Payment policy
      </AppText>
      <AppText
        name="body2-medium"
        class="tutor-policy__edit"
        color="blue-600"
        @click="setEdit"
      >
        Edit
        <AppIcon
          :icon="faPenToSquare"
          size="small"
        />
      </AppText>
    </div>
    <div class="tutor-policy__wrapper">
      <PaymentPolicyRow
        title="Demo Math"
        :category="TutorCategoryType.DemoMath"
      />
      <PaymentPolicyRow
        title="Paid Math"
        :category="TutorCategoryType.PaidMath"
      />
      <PaymentPolicyRow
        title="Demo ELA"
        :category="TutorCategoryType.DemoEla"
      />
      <PaymentPolicyRow
        title="Paid ELA"
        :category="TutorCategoryType.PaidEla"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TutorKanbanPolicy.scss" />
